import { useCallback, useEffect, useState } from 'react';
import { Product } from '@setvi/shared/interfaces';
import { enqueueSnackbar } from 'notistack';
import { useMutation } from '@tanstack/react-query';
import { orderItemsHistory } from '@setvi/shared/services';
import { OrderItemHistory } from '@setvi/shared/services/react-query/query/orders/types';

export interface UseReorderHistoryProps {
  productId: Product['_id'];
  accountId: string;
  addressId: string;
}

export const useProducts = ({
  productId,
  accountId,
  addressId
}: UseReorderHistoryProps) => {
  const [products, setProducts] = useState<OrderItemHistory[]>([]);

  const { mutateAsync, isLoading } = useMutation(orderItemsHistory());

  const getOrderHistory = useCallback(async () => {
    try {
      const response = await mutateAsync({
        productId,
        accountId,
        addressId
      });
      if (response?.length) setProducts(response);
    } catch (error) {
      enqueueSnackbar('Error occurred while fetching order history data', {
        variant: 'error',
        autoHideDuration: 8000
      });
    }
  }, [mutateAsync, productId, accountId, addressId]);

  useEffect(() => {
    getOrderHistory();
  }, [getOrderHistory]);

  return { products, isLoading };
};
